import { create } from 'zustand';

export type ToastLevel = 'success' | 'error' | 'info' | 'warning';

export interface ToastItem {
  id: string;
  level: ToastLevel;
  title: string;
  message?: string;
}

interface ToastState {
  toasts: ToastItem[];
  push(t: Omit<ToastItem, 'id'>): void;
  dismiss(id: string): void;
}

export const useToastStore = create<ToastState>((set) => ({
  toasts: [],
  push: (t) => {
    const id = crypto.randomUUID();
    set((s) => ({ toasts: [...s.toasts, { ...t, id }] }));
    setTimeout(() => {
      set((s) => ({ toasts: s.toasts.filter((x) => x.id !== id) }));
    }, 6000);
  },
  dismiss: (id) => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
}));

export const toast = {
  success: (title: string, message?: string) =>
    useToastStore.getState().push({ level: 'success', title, message }),
  error: (title: string, message?: string) =>
    useToastStore.getState().push({ level: 'error', title, message }),
  info: (title: string, message?: string) =>
    useToastStore.getState().push({ level: 'info', title, message }),
  warning: (title: string, message?: string) =>
    useToastStore.getState().push({ level: 'warning', title, message }),
};
